import { render } from "./AddBatch.vue?vue&type=template&id=9ba2e084&scoped=true"
import script from "./AddBatch.vue?vue&type=script&lang=js"
export * from "./AddBatch.vue?vue&type=script&lang=js"

import "./AddBatch.vue?vue&type=style&index=0&id=9ba2e084&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ba2e084"]])

export default __exports__